import { environment } from '../environments/environment';

/**
 * Base URL for Castor API.
 * Runtime override is preserved for deployments that inject config late.
 */
type WindowWithApiUrl = Window & { __API_URL__?: string };

function getRuntimeApiUrl(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const runtimeValue = (window as WindowWithApiUrl).__API_URL__?.trim();
  return runtimeValue ? runtimeValue : undefined;
}

export const CASTOR_API_URL = getRuntimeApiUrl() ?? environment.apiBaseUrl;
